/** @format */

import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { _$, Dialog, Form, FormItem, Input, Message } from '@king-design/react'
import { TriggerRecordItemProp } from '../container'
import { enableTrigger } from 'src/api/ApiEventOpsTrigger'

interface DeleteRuleDialogProps {
  className?: string
  visible: boolean
  record: TriggerRecordItemProp
  onClose: (update?: boolean) => void
}

const DeleteRuleDialog: React.FC<DeleteRuleDialogProps> = ({
  className,
  visible,
  record,
  onClose
}) => {
  const remarkForm = useRef(null)
  const [remark, setRemark] = useState<string>('')

  const formSubmit = async () => {
    const validate = await remarkForm?.current?.validate()
    if (validate) {
      const result = await enableTrigger({
        ID: record?.ID,
        Enable: record?.Status === 2 ? false : true,
        Remark: remark
      })
      if (result) {
        Message.success(record?.Status === 2 ? _$("停用成功") : _$("启用成功"))
        onClose(true)
        setRemark('')
      }
    }
  }

  return (
    <Dialog
      value={visible}
      width={500}
      title={`确认${record?.Status === 2 ? _$("停用") : _$("启用")}规则吗？`}
      onChangeValue={show => {
        if (!show) {
          onClose()
          setRemark('')
        }
      }}
      ok={formSubmit}
    >
      {record ? (
        <div className={className}>
          <Form ref={remarkForm}>
            <FormItem
              hideLabel
              value={remark}
              rules={{ required: true }}
              messages={{ required: _$("请填写操作备注") }}
            >
              <Input
                width={450}
                type="textarea"
                placeholder={_$('请填写操作备注')}
                rows={4}
                value={remark}
                onChangeValue={value => {
                  setRemark(value)
                }}
              />
            </FormItem>
          </Form>
        </div>
      ) : null}
    </Dialog>
  )
}

export default styled(DeleteRuleDialog)`
  .ksc-space {
    text-align: center;
    margin-top: 16px;
    padding-left: 38px;
    .k-input {
      margin-top: 16px;
    }
  }
`
